<template>
    <div id="PostToBlogBtn">
        <indicator-button :class="btnClasses" :click="click" :isLoading="isLoading"><slot/></indicator-button>
    </div>


</template>

<script>
    import IndicatorButton from "./IndicatorButton";
    export default {
      components: {IndicatorButton},
      props: {
            method: {},
            classes: {},
            isLoading: false,

        },
        data() {
            return {
              isOpen: false,
              isPosting: false
            }
        },
        computed: {
            btnClasses(){
                let cls = '';
                if(this.blogs>1) cls+= 'dropdown-toggle ';
                cls+= this.classes;
                return cls;
            },
            blogs(){
                return this.$store.state.user.blogs;
            },
        },
        created() {

        },
        methods: {
            click(blog){
                if(!this.blogs || this.blogs.length < 1){
                    this.$bus.$emit('error', "You don't have any Blogs yet!");
                    return;
                }
                if(this.blogs.length>1){
                    this.$bus.$emit('blogPicker', (blog)=>{
                        this.isPosting = true;
                        this.method(blog, (err)=>{this.isPosting = false;})
                    })
                } else {
                    this.isPosting = true;
                    this.method(this.blogs[0], (err)=>{this.isPosting = false;});
                }
            }
        }
    }
</script>

<style lang="sass" scoped>
    #PostToBlogBtn
        display: inline-block
</style>



// WEBPACK FOOTER //
// src/components/ui/buttons/PostToBlogButton.vue